<HomeNavBar/>

<!-- Header -->

     <button
      class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
      @click="$router.back()">
      <i class="bi bi-arrow-left fs-4"></i>
    </button>

<div class="container-fluid mb-4 mt-3">
  <div class="text-center">
    <h4 class="fw-bold text-primary mb-2">
      Uploaded Documents Resources
    </h4>
  </div>

<!-- Loader -->
<div v-if="loading_recent" class="text-center my-5">
  <div class="spinner-border text-primary"></div>
</div>

 <div v-else-if="!filteredDocuments.length" class="text-center py-5 my-4">
  <i class="bi bi-folder2-open fs-1 text-muted mb-2"></i>
  <h5 class="text-dark mb-2">No documents found</h5>
  <p class="text-muted mb-0">Upload or add document resources on your feed to see them here.</p>
</div>

<!-- Documents Grid -->
<div class="mt-4"  v-else>
  <div class="row g-4">
    <div
    class="col-6 col-sm-4 col-md-3 col-lg-2"
      v-for="document in filteredDocuments"
      :key="document.id">
      <div class="file-card p-3 h-100 d-flex flex-column">

  <!-- Top Section -->
  <div class="d-flex align-items-center mb-3 w-100">

    <div
      class="file-icon-box me-3 d-flex align-items-center justify-content-center text-white flex-shrink-0"
      :class="get_file_class(document.file.name)"
    >
      {{ get_file_label(document.file.name) }}
    </div>

    <div class="file-name-wrap flex-grow-1">
      <h6 class="file-name mb-0 w-100"
          :title="document.file.name">
        {{ document.file.name }}
      </h6>
    </div>

  </div>

  <!-- Actions -->
  <div class="d-flex justify-content-between align-items-center mt-auto file-actions">

    <button class="btn btn-sm action-btn" @click="open_preview(document)">
      <i class="bi bi-eye"></i>
    </button>

    <button type="button" class="btn btn-sm action-btn"
            @click.prevent="toggleLibrarySave(document)">
      <i :class="document.is_saved ? 'bi bi-bookmark-check-fill' : 'bi bi-bookmark'"></i>
    </button>

    <button class="btn btn-sm action-btn" @click="downloadFile(document.file)">
      <i class="bi bi-download"></i>
    </button>

  </div>

</div>
    </div>

  </div>
</div>
</div>

<teleport to="body">

<div class="modal fade" id="preview_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body text-center position-relative">

        <!-- Loader Spinner -->
        <div v-if="loading_preview" class="d-flex justify-content-center align-items-center" width="100%" height="100%">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- PDF Preview -->
        <div v-if="preview_type === 'pdf'" class="ratio ratio-16x9">
          <iframe :src="preview_url" width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
        </div>

        <!-- Image Preview -->
        <div v-else-if="preview_type === 'image'">
          <img :src="preview_url" class="img-fluid rounded" @load="on_content_loaded" />
        </div>

        <!-- Video Preview -->
        <div v-else-if="preview_type === 'video'">
          <video controls class="img-fluid rounded" @loadedmetadata="on_content_loaded">
            <source :src="preview_url" :type="'video/' + preview_url.split('.').pop()" />
            Your browser does not support the video tag.
          </video>
        </div>

        <!-- Audio Preview -->
        <div v-else-if="preview_type === 'audio'">
          <audio controls class="w-100 my-3" @loadedmetadata="on_content_loaded">
            <source :src="preview_url" :type="'audio/' + preview_url.split('.').pop()" />
            Your browser does not support the audio element.
          </audio>
        </div>

        <!-- Office Documents (DOCX, XLSX, PPTX) -->
        <div v-else-if="preview_type === 'office'" class="ratio ratio-16x9">
          <iframe
            :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
            width="100%"
            height="100%"
            frameborder="0"
            @load="on_content_loaded"
          ></iframe>
        </div>

        <!-- Text Files (TXT, CSV) -->
        <div v-else-if="preview_type === 'text'">
          <iframe :src="preview_url" width="100%" height="500px" frameborder="0" @load="on_content_loaded"></iframe>
        </div>

        <!-- Other / Unsupported Files -->
        <div v-else @load="on_content_loaded">
          <p>Preview not available. You can
            <a :href="preview_url" target="_blank" download>download the file</a> to view it.
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
  </teleport>